var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import makeStyles from '@material-ui/core/styles/makeStyles';
import InputLabel from '@material-ui/core/InputLabel';
import { InformationTooltip, useFormInputStyles } from '.';
;
var FormInputLabel = function (_a) {
    var id = _a.id, description = _a.description, tooltip = _a.tooltip, labelAdornment = _a.labelAdornment, maxLength = _a.maxLength, maxLengthContent = _a.maxLengthContent, _b = _a.classes, _c = _b === void 0 ? {} : _b, labelContainer = _c.labelContainer, label = _c.label, maxLengthClass = _c.maxLength;
    var classes = useStyles();
    var formInputClasses = useFormInputStyles();
    return (_jsxs("div", __assign({ className: clsx(formInputClasses.containLables, labelContainer) }, { children: [_jsxs("div", __assign({ className: classes.labelAndTooltip }, { children: [_jsx(InputLabel, __assign({ htmlFor: id, className: clsx(formInputClasses.label, label) }, { children: description }), void 0),
                    tooltip && _jsx(InformationTooltip, { text: tooltip }, void 0)] }), void 0),
            maxLength ? _jsx("div", __assign({ className: maxLengthClass }, { children: maxLengthContent }), void 0) : null, labelAdornment && labelAdornment] }), void 0));
};
export default FormInputLabel;
var useStyles = makeStyles(({
    labelAndTooltip: {
        display: 'flex',
        alignItems: 'center',
        gap: 4
    }
}));
//# sourceMappingURL=FormInputLabel.js.map